import { WorkflowStage } from '@servicetitan/financing-workflow-shared';

export const SUBMIT_TO_DECISION_STAGES: WorkflowStage[] = [
    'submitting',
    'reviewing',
    'decision',
    'accept-offer',
];
